export const fastSerialize = <T>(value: T): string => {
	if (value === null || value === undefined) {
		return String(value);
	}

	if (typeof value === "string") {
		return value;
	}

	if (typeof value === "number" || typeof value === "boolean") {
		return String(value);
	}

	try {
		return JSON.stringify(value);
	} catch {
		return String(value);
	}
};

export const fastDeserialize = <T>(value: string): T => {
	if (value === "null") {
		return null as T;
	}

	if (value === "undefined") {
		return undefined as T;
	}

	if (value === "true") {
		return true as T;
	}

	if (value === "false") {
		return false as T;
	}

	if (/^-?\d+(\.\d+)?$/.test(value)) {
		// Avoid converting large numeric strings to numbers to prevent precision loss.
		// JavaScript numbers (IEEE 754) cannot safely represent integers larger than
		// Number.MAX_SAFE_INTEGER. Such large numbers are often used as unique
		// identifiers (UIDs) and should be preserved as strings.
		if (!value.includes(".") && value.length > 15) {
			return value as T;
		}

		return Number(value) as T;
	}

	if (value.startsWith("{") || value.startsWith("[")) {
		try {
			return JSON.parse(value);
		} catch {
			return value as T;
		}
	}

	return value as T;
};
